export const sanitizeUfoName = (name: string) => {
	const nameNoUnderscore = name.replace(/_/g, '-');
	return nameNoUnderscore;
};
